export default "__VITE_ASSET__BVGh$qpI__"